<template>
  <div class="mx-6 my-6 relative">
    <div class="sm:flex sm:items-center">
      <div class="flex-auto flex items-center space-x-5">
        <div class="flex-shrink-0">
          <div class="relative bg-orange-600/70 rounded-xl p-1">
            <mdicon name="label-variant" size="62" class="text-orange-100" aria-hidden="true"></mdicon>
          </div>
        </div>
        <div class="">
          <h1 class="text-2xl font-bold text-gray-900">Macros Triggers</h1>
          <p class="text-sm font-medium text-gray-500">Define how Macro is triggered. You can set up Macro to run when specific tag is added to a ticket.</p>
        </div>
      </div>

      <div class="flex items-center mt-4 sm:ml-16 sm:mt-0 sm:flex-none"></div>
    </div>

    <div class="mt-4">
      <ManageProviderMacros :integrations-allowed="['freshdesk', 'zendesk', 'freshservice', 'kustomer', 'gorgias', 'salesforce', 'intercom']" type="macrotrigger" />
    </div>
  </div>
</template>

<script setup>
  import ManageProviderMacros from '@/components/Settings/ManageProviderMacros.vue';
</script>
